import { authAction } from '../actionTypes'

const initialState = {
  ownerData: {},
  resetPasswordData: {},
  categoryList:[],
  SubcategoryList:[],
  loader: false,
  loginStatus: false,

}

export default function auth(state = initialState, {type, payload}) {
  // console.log("payload-------34", payload)
  localStorage.setItem("payload", JSON.stringify(payload))
  switch(type) {
    case authAction.OWNER_LOGIN_INITIATE: {
      return {
        ...state, loader: true, ownerData: {}
      }
    }
    case authAction.OWNER_LOGIN_SUCCESS: {
					delete payload.data.password
				delete payload.data.plainPassword
       window.localStorage.setItem('ownerLogin', JSON.stringify(payload.data))
       
      return {
        ...state, loader: false, loginStatus: true, ownerData: payload.data
      }
    }
    case authAction.OWNER_LOGIN_FAILURE: {
      return {
        ...state, loader: false,ownerData: payload
      }
    }


    case authAction.OWNER_CHANGE_PASSWORD_INITIATE: {
      return {
        ...state, resetPasswordData: {}
      }
    }
    case authAction.OWNER_CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state, resetPasswordData:payload.data
      }
    }
    case authAction.OWNER_CHANGE_PASSWORD_FAILURE: {
      return {
        ...state, resetPasswordData: {}
      }
    }

    

    case authAction.OWNER_CATEGORY_INITIATE: {
      return {
        ...state, categoryList: []
      }
    }
    case authAction.OWNER_CATEGORY_SUCCESS: {
      return {
        ...state, categoryList:payload.data
      }
    }
    case authAction.OWNER_CATEGORY_FAILURE: {
      return {
        ...state, categoryList: []
      }
    }


    

    default: 
    return state
}
}